import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-菜单",
  "use": "icon-菜单-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-菜单\">\n    <title>icon/10pt/菜单</title>\n    <g id=\"icon-菜单_icon/10pt/菜单\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\">\n        <line x1=\"83.8414258\" y1=\"48\" x2=\"12.000156\" y2=\"48\" id=\"icon-菜单_路径-2备份-3\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n        <line x1=\"83.8414258\" y1=\"73\" x2=\"12.000156\" y2=\"73\" id=\"icon-菜单_路径-2备份-5\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n        <line x1=\"83.8414258\" y1=\"23\" x2=\"12.000156\" y2=\"23\" id=\"icon-菜单_路径-2备份-4\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/菜单.svg
// module id = dShQ
// module chunks = 2